import { ApiUrl } from '@common/enums';
import { CutoutLaborModel } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const cutoutLaborService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchCutoutLabor: builder.query<CutoutLaborModel[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.CUTOUT_LABOR,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchCutoutLaborQuery } = cutoutLaborService;
